import Swiper from 'swiper';
import $ from 'jquery';


const sliderContainer = $('.js-footer-partners');
const sliderItems = $('.js-footer-partners .swiper-slide');

const breakpoint = window.matchMedia('(min-width: 640px)');

let partnersSlider;

function enableSwiper() {
  if (sliderItems.length > 2 && sliderItems.length < 6) {
    partnersSlider = new Swiper(sliderContainer, {
      slidesPerView: 'auto',
      loop: true,
      speed: 600,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false
      },
    });
  } else if (sliderItems.length > 5) {
    partnersSlider = new Swiper(sliderContainer, {
      slidesPerView: 'auto',
      loop: true,
      speed: 600,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false
      }
    });
  } else {
    return;
  }
}

function breakpointChecker() {
  if (breakpoint.matches === true) {
    if (partnersSlider !== undefined && sliderItems.length < 6) {
      partnersSlider.destroy(true, true);
    } else if (sliderItems.length > 5) {
      enableSwiper();
    }
  } else if (breakpoint.matches === false) {
    enableSwiper();
  }
}

if ( sliderContainer.length ) {
  breakpoint.addListener(breakpointChecker);
  breakpointChecker();
}

